import { render, staticRenderFns } from "./MultiSelectForm.vue?vue&type=template&id=6a21030b"
import script from "./MultiSelectForm.vue?vue&type=script&lang=js"
export * from "./MultiSelectForm.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectForm.vue?vue&type=style&index=0&id=6a21030b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports